import { UnidadeImportacao } from "core/features/unidades/typings/unidade";
import { TextEditor } from "react-data-grid";
import type { Column } from "react-data-grid";

export const columns: readonly Column<UnidadeImportacao>[] = [
  {
    key: "index",
    name: "",
    width: 40,
    resizable: false,
    editable: false,
  },
  {
    key: "unidade",
    name: "Unidade",
    width: 100,
  },
  {
    key: "bloco",
    name: "Bloco/Quadra",
    width: 120,
  },
  {
    key: "fracao",
    name: "Fração",
    width: 100,
  },
  {
    key: "peso",
    name: "Peso",
    width: 100,
  },
  {
    key: "area",
    name: "Área",
    width: 100,
  },
  {
    key: "area_construida",
    name: "Área construída",
    width: 100,
  },
  {
    key: "abatimento",
    name: "Abatimento",
    width: 120,
  },
  {
    key: "proprietario_nome",
    name: "Nome Proprietário",
  },
  {
    key: "proprietario_telefone",
    name: "Telefone Proprietário",
    width: 170,
  },
  {
    key: "proprietario_celular",
    name: "Celular Proprietário",
    width: 170,
  },
  {
    key: "proprietario_forma_de_entrega",
    name: "Forma de Entrega Proprietário",
  },
  {
    key: "proprietario_cpf/cnpj",
    name: "CPF/CNPJ Proprietário",
  },
  {
    key: "proprietario_rg",
    name: "RG Proprietário",
    width: 170,
  },
  {
    key: "proprietario_email",
    name: "Email Proprietário",
  },
  {
    key: "proprietario_endereco",
    name: "Logradouro Proprietário",
  },
  {
    key: "proprietario_numero",
    name: "Número Proprietário",
  },
  {
    key: "proprietario_complemento",
    name: "Complemento Proprietário",
  },
  {
    key: "proprietario_cep",
    name: "CEP Proprietário",
    width: 170,
  },
  {
    key: "proprietario_cidade",
    name: "Cidade Proprietário",
  },
  {
    key: "proprietario_bairro",
    name: "Bairro Proprietário",
  },
  {
    key: "proprietario_estado",
    name: "Estado Proprietário",
    width: 170,
  },

  {
    key: "inquilino_nome",
    name: "Nome Inquilino",
  },
  {
    key: "inquilino_telefone",
    name: "Telefone Inquilino",
    width: 170,
  },
  {
    key: "inquilino_celular",
    name: "Celular Inquilino",
    width: 170,
  },
  {
    key: "inquilino_forma_de_entrega",
    name: "Forma de Entrega Inquilino",
  },
  {
    key: "inquilino_cpf/cnpj",
    name: "CPF/CNPJ Inquilino",
  },
  {
    key: "inquilino_rg",
    name: "RG Inquilino",
    width: 170,
  },
  {
    key: "inquilino_email",
    name: "Email Inquilino",
  },
  {
    key: "inquilino_endereco",
    name: "Logradouro Inquilino",
  },
  {
    key: "inquilino_numero",
    name: "Número Inquilino",
  },
  {
    key: "inquilino_complemento",
    name: "Complemento Inquilino",
  },
  {
    key: "inquilino_cep",
    name: "CEP Inquilino",
  },
  {
    key: "inquilino_cidade",
    name: "Cidade Inquilino",
  },
  {
    key: "inquilino_bairro",
    name: "Bairro Inquilino",
  },
  {
    key: "inquilino_estado",
    name: "Estado Inquilino",
  },
].map((col: Column<UnidadeImportacao>) => ({
  ...col,
  width: col.width || 250,
  resizable: true,
  editorOptions:
    col.editable === false
      ? null
      : {
          editOnClick: true,
        },
  editor: col.editor || TextEditor,
}));
